import React, { useEffect, useState } from "react";
import { StyleSheet } from "react-native";

import LastWeekHelper from "./LastWeekHelper";
import { hhMMToDec } from "../../../../helpers/utils";
import Dialog from "../../common/dialog";
import TimePicker from "../../common/timepicker/TimePicker";

export default function LastWeekTimePicker({
  selectedItem,
  onClose = () => {},
  onChange = () => {},
  minutesInterval = 1,
}) {
  const [decTime, setDecTime] = useState(0);
  const [maxHours, setMaxHours] = useState(0);

  useEffect(() => {
    if (!selectedItem) return;

    setDecTime(selectedItem.time);
    setMaxHours(
      LastWeekHelper.isTotalHours(selectedItem) || selectedItem.isDaySelected
        ? 24
        : 168,
    );
  }, [selectedItem]);

  const onChangeTime = (selectedTime) => {
    setDecTime(selectedTime);
  };

  const confirmTime = () => {
    onChange(hhMMToDec(decTime));
    onClose();
  };

  return (
    <>
      {selectedItem ? (
        <Dialog.Container style={styles.container} onClose={onClose}>
          <TimePicker
            selectedTime={selectedItem.time}
            minutesInterval={minutesInterval}
            maxHours={maxHours}
            has24Format
            showLabels
            onChange={(time) => onChangeTime(time)}
          />

          <Dialog.Button
            style={[styles.button]}
            label="DONE"
            onPress={confirmTime}
          />
        </Dialog.Container>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  button: {
    marginTop: 10,
  },
});
